export const GUESTBOOK_CLUSTER_SIZE = 8;
export const GUESTBOOK_PAGE_SIZE = 24;
export const GUESTBOOK_MAX_PAGE_SIZE = 50;

export function guestbookPageLimit(value: unknown) {
  const parsed = Number(value);
  if (!Number.isSafeInteger(parsed) || parsed < 1) return GUESTBOOK_PAGE_SIZE;
  return Math.min(parsed, GUESTBOOK_MAX_PAGE_SIZE);
}
